const appConstant = {
  rootPath: '/',
  clientId: 'ad460647430e7fb7bcf65241eb2ba83e',
  oauthUrl: 'https://api.auto.mydlink.com/oauth/authorize',
  redirectUrl: 'https://sso.dlink.com/oauth',
  baseUrl: 'https://api.auto.mydlink.com/',
  privacyUrl: 'https://d1rvtd08ngd4ef.cloudfront.net/new+mydlink/privacy_and_tos/privacy_policy_content.html?lang=',
  termsOfUseUrl: 'https://d1rvtd08ngd4ef.cloudfront.net/new+mydlink/privacy_and_tos/terms_of_use_content.html?lang=',
  curUser: {}
};

export default appConstant;



// WEBPACK FOOTER //
// ./src/Config.js